import { ThreadSummary } from '@core/tellent-assistant-types';
import { IconName } from '@core/user-interface-legacy';

export type ThreadMenuItemId = 'pin' | 'remove';

export interface ThreadMenuItem {
  id: ThreadMenuItemId;
  labelKey: string;
  icon: IconName;
  destructive?: boolean;
}

export interface ThreadMenuAction {
  id: ThreadMenuItemId;
  thread: ThreadSummary;
}

/**
 * Single source of the per-thread context menu: the thread drawer renders it
 * as a hover-kebab dropdown on desktop, the chat panel as a bottom options
 * sheet on touch hosts. Groups map to dropdown dividers and to separate sheet
 * cards respectively.
 */
export const threadMenuGroups = (thread: ThreadSummary): ThreadMenuItem[][] => [
  [
    thread.pinned
      ? { id: 'pin', labelKey: 'tlc.tellent_assistant.header.menu_unpin', icon: 'pin-off' }
      : { id: 'pin', labelKey: 'tlc.tellent_assistant.header.menu_pin', icon: 'pin' },
  ],
  [
    {
      id: 'remove',
      labelKey: 'tlc.tellent_assistant.header.menu_remove',
      icon: 'delete',
      destructive: true,
    },
  ],
];
